// @flow

import type {
  PropsSchema,
  EventSourceMap,
  BasicProps
} from '../../type'

import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  url: string,
  events: EventSourceMap,
  reqParam?: string,
  formValues: { [string]: any },
};



@computeData({ includeData: true, includeVisible: false })
export default class CallApi extends React.PureComponent<Props> {
  static defaultProps = {
    isShow: true,
  };

  static schema: PropsSchema = [
    {
      key: 'url',
      type: 'textarea',
      title: '路径'
    }
  ];

  componentDidMount () {
    window.addEventListener('beforeunload',this.beforeUnload)
  }

  beforeUnload=()=>{
    const { jsEnv, url } = this.props
    const oriPath = jsEnv.getString(url)
    let  b = new Image(1,1);
    b.src = oriPath;
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload',this.beforeUnload)
  }

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/Beforeunload.js